/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../../teva/navigation/navigation.ts" />
/// <reference path="../intercom/intercom.ts" />
/// <reference path="../modals/modals.ts" />

namespace OfficeGuy {
    export class Smooth {
        static StatesCount = 0;

        // http://stackoverflow.com/questions/6238351/fastest-way-to-detect-external-urls
        static IsExternal(URL): boolean {
            var match = URL.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
            if (typeof match[1] === "string" && match[1].length > 0 && match[1].toLowerCase() !== location.protocol)
                return true;
            if (typeof match[2] === "string" && match[2].length > 0 && match[2].replace(new RegExp(":(" + { "http:": 80, "https:": 443 }[location.protocol] + ")?$"), "") !== location.host)
                return true;
            return false;
        }

        static IsHash(URL): boolean {
            return URL.indexOf(window.location.pathname) > 0 && URL.indexOf("#") > 0;
        }

        static ShouldLoad($Anchor, Blacklist): boolean {
            var URL = $Anchor.prop("href");
            return !Smooth.IsExternal(URL) && !Smooth.IsHash(URL) && !$Anchor.is(Blacklist);
        }

        // * Prevents jQuery from stripping elements from $(html) https://gist.github.com/cowboy/742952
        static HtmlDoc(HTML) {
            var Elements = $();
            var MatchTag = /<(\/?)(html|head|body|title|base|meta)(\s+[^>]*)?>/ig;
            var Prefix = 'ss' + Math.round(Math.random() * 100000);
            var HtmlParsed = HTML.replace(MatchTag, function (Tag, Slash, Name, Attributes) {
                var obj = {};
                if (!Slash) {
                    Elements = Elements.add('<' + Name + '/>');
                    if (Attributes) {
                        $.each($('<div' + Attributes + '/>')[0].attributes, function (i, attr) {
                            obj[attr.name] = attr.value;
                        });
                    }
                    Elements.eq(-1).attr(obj);
                }
                return '<' + Slash + 'div' + (Slash ? '' : ' id="' + Prefix + (Elements.length - 1) + '"') + '>';
            });

            // If no placeholder elements were necessary, just return normal
            // jQuery-parsed HTML.
            if (!Elements.length)
                return $(HTML);

            // Create parent node if it hasn't been created yet.
            var Parent = <any>$(document.createElement('div'));

            // Create the parent node and append the parsed, place-held HTML.
            Parent.html(HtmlParsed);

            // Replace each placeholder element with its intended element.
            $.each(Elements, function (i) {
                var $Element = Parent.find('#' + Prefix + i).before(Elements[i]);
                Elements.eq(i).html($Element.contents());
                $Element.remove();
            });

            return Parent.children().unwrap();
        }

        static StorePage(ProcessData, URL, HTML, IsModal, IsSimpleModal, SkipModalState) {
            ProcessData.OriginalHTML = HTML;
            HTML = (HTML instanceof jQuery) ? HTML : Smooth.HtmlDoc(HTML);
            ProcessData.Status = "Loaded";
            ProcessData.Title = HTML.find("title").text();
            ProcessData.HTML = HTML;
            ProcessData.IsModal = IsModal;
            ProcessData.IsSimpleModal = IsSimpleModal;
            ProcessData.SkipModalState = SkipModalState;
        }

        static Init($MainElement) {
            if ($MainElement.length > 1) {
                console.warn("Too many main elements");
                return;
            }
            if (!$MainElement[0].id) {
                console.warn("Every smoothState container needs an id but the following one does not have one:", this);
                return;
            }
            if ($MainElement.data("smooth"))
                return;

            $MainElement.data("smooth", "1");
            Smooth.$MainElement = $MainElement;
            Smooth.MainElementID = $MainElement.prop('id');

            if (history.state === null)
                history.replaceState({ id: $MainElement.prop('id') }, document.title, Smooth.CurrentHref);

            Smooth.BindEvents();
        }

        static $MainElement;
        static MainElementID;

        /** Variable that stores data after it is requested */
        static ProcessData: any = {};

        /** Variable that stores the current url */
        static RequestedURL = "";
        static RequestedPreventModal;
        static $RequestedOriginalLink;

        /** Url of the content that is currently displayed */
        static CurrentHref = window.location.href;

        /** Current running ajax request or last */
        static CurrentAjaxRequest = null;

        // Forwards history on canceling pop state
        static ForwardOnCancellingHistory(IsPopped) {
            if (Smooth.RequestedURL == "" && IsPopped)
                window.history.forward();
        }

        // Loads the contents of a url into our container
        static Load(URL, IsPopped, PreventModal, $OriginalLink) {
            if ($OriginalLink != null && $OriginalLink.hasClass("og-dirty-skip"))
                Smooth.LoadWithoutConfirmation(URL, IsPopped, PreventModal, $OriginalLink);
            else {
                Forms.DirtyNavigation(function () {
                    Smooth.LoadWithoutConfirmation(URL, IsPopped, PreventModal, $OriginalLink);
                });
            }
        }

        static LoadWithoutConfirmation(URL: string, IsPopped: boolean, PreventModal: boolean, $OriginalLink) {
            if (URL[0] == '/')
                URL = window.location.origin + URL;
            Smooth.RequestedURL = URL;
            Smooth.RequestedPreventModal = PreventModal;
            Smooth.AbortAjax();

            Navigation.Loading_Show(false);

            var Responses = {
                Loaded: function () {
                    Smooth.UpdateContentFromCache(URL, IsPopped);
                    Navigation.Loading_Hide();
                },
                Fetching: function () {
                    Smooth.ForwardOnCancellingHistory(IsPopped);
                    if (Smooth.RequestedURL != URL)
                        return;

                    setTimeout(function () {
                        Responses[Smooth.ProcessData.Status]();
                    }, 10);
                },
                Error: function () {
                    window.location.href = URL;
                }
            };

            Smooth.ForwardOnCancellingHistory(IsPopped);
            if (Smooth.RequestedURL != URL)
                return;

            Smooth.Fetch(URL, $OriginalLink);

            Responses[Smooth.ProcessData.Status]();
        }

        static UpdateContentFromCache(URL, IsPopped) {
            if (URL[0] == '/')
                URL = window.location.origin + URL;
            var ProcessData = Smooth.ProcessData;
            var Title = ProcessData.Title;
            var HTML = ProcessData.HTML;

            Smooth.ForwardOnCancellingHistory(IsPopped);
            if (Smooth.RequestedURL != URL)
                return;

            if (!(HTML instanceof jQuery))
                HTML = Smooth.HtmlDoc(HTML);

            if (ProcessData.IsModal) {
                var ModalParams = <any>{
                    History_Type: "ShowHTMLGetDialog",
                    ReplaceModal: true,
                    ConvertToAjax: true,
                    DisableAutoShow: true,
                    Method: "GET",
                    Title: Title,
                    PushState: !ProcessData.SkipModalState,
                    URL: URL,
                    FullURL: URL,
                    Simple: ProcessData.IsSimpleModal
                };
                ModalParams.History_Data = ModalParams;
                var $Modal = Modals.Create(ModalParams);
                $(".og-navigation-bar:first", $Modal).remove();

                //OfficeGuy.ExternalProvider.PageLoad(Params.URL, false);
                $(".modal-content", $Modal).empty().prepend(HTML);

                Forms.ParseDynamicContent_Init();
                (<any>$.validator).unobtrusive.parseDynamicContent($Modal);
                $(document).trigger("OG.ModalLoading", $Modal);
                Modals.Show($Modal);
                Modals.ModalLoaded($Modal);
                Forms.ConvertFormToAjax($("form", $Modal), $(".modal-content", $Modal), null, true);

                return;
            }

            var $Content = HTML.find('#' + Smooth.MainElementID);
            if ($Content.length == 0)
                $Content = null;

            if ($Content) {
                $("#main-inner").fadeOut(400, function () {
                    if (URL != Smooth.RequestedURL) {
                        Smooth.ForwardOnCancellingHistory(IsPopped);
                        $("#main-inner").fadeIn();
                        return;
                    }
                    if (!IsPopped) {
                        if (Smooth.CurrentHref != URL) {
                            Smooth.StatesCount++;
                            window.history.pushState({ id: Smooth.$MainElement.prop('id') }, Title, URL);
                        }
                    }

                    document.title = Title;
                    Smooth.CurrentHref = URL;

                    OfficeGuy.Modals.HideAll(true);
                    Smooth.$MainElement[0].className = $Content[0].className;
                    Smooth.$MainElement.html($Content.html());

                    (<any>$.validator).unobtrusive.parseDynamicContent($('#main-inner').find('form'));

                    $("#main-inner")
                        .hide()
                        .fadeIn(400)
                    $("html, body").scrollTop(0);
                    Smooth.RequestedURL = "";
                });
            }
            else if (!$Content) {
                $("html").html((<any>$).htmlDoc(ProcessData.OriginalHTML));
                console.warn("No element with an id of '" + Smooth.MainElementID + "' in response from " + URL);
            }
            else
                window.location.href = URL;
        }

        static Fetch(URL, $OriginalLink) {
            Smooth.ProcessData = {
                Status: "Fetching",
                $OriginalLink: $OriginalLink
            };

            Smooth.CurrentAjaxRequest = $.ajax({
                url: URL,
                headers: {
                    "x-smooth": "1",
                    "x-modal": Smooth.RequestedPreventModal || OfficeGuy.Common.IsBrowserLowResolution() ? "0" : null
                },
                success: function (Response, Status, XHR) {
                    if (URL != Smooth.RequestedURL)
                        return;

                    var IsModal = XHR.getResponseHeader("x-modal") == "1";
                    var IsSimpleModal = XHR.getResponseHeader("x-modal-simple") == "1";
                    var SkipModalState = XHR.getResponseHeader("x-modalstate");
                    if (typeof (Response) == "string")
                        Smooth.StorePage(Smooth.ProcessData, URL, Response, IsModal, IsSimpleModal, SkipModalState);
                    else if (Response.RedirectURL == ".")
                        window.location.reload();
                    else if (Response.ErrorMessage != null) {
                        setTimeout(function () {
                            Navigation.Loading_Hide();
                            Modals.ShowMessageDialog(Response.ErrorTitle == null ? "הודעת מערכת" : Response.ErrorTitle, Response.ErrorMessage, Response.ErrorButton);
                        }, 200);
                    }
                    else {
                        Navigation.Redirect(Response.RedirectURL, Response.AllowRedirectModal == false);
                        Navigation.Loading_Hide();
                    }
                },
                error: function () {
                    if (URL == Smooth.RequestedURL)
                        Smooth.ProcessData.Status = "Error";
                }
            });
        }

        static AbortAjax() {
            if (Smooth.CurrentAjaxRequest != null && Smooth.CurrentAjaxRequest.readyState != 4)
                Smooth.CurrentAjaxRequest.abort();
        }

        static PendingHashState;
        static PendingHashTitle;
        static PendingHashReplaceURL;

        static ReplacePath(Path) {
            window.history.replaceState(window.history.state, document.title, Path);
        }

        static BindEvents() {
            $(document.documentElement).on("click", "a[href]", function (Event) {
                if (Teva.Navigation.IsNewWindowEvent(Event))
                    return;

                var $Link = $(Event.currentTarget);
                var URL = $Link.prop("href");

                if (URL == "https://app.sumit.co.il/help/support/") {
                    OfficeGuy.Intercom.Show();
                    Event.preventDefault();
                    return;
                }
                if (!Smooth.ShouldLoad($Link, ".no-smoothstate, [target], [href*='myofficeguy.com/crm/downloadfile']"))
                    return;

                if (!Event.isDefaultPrevented()) {
                    Event.preventDefault();
                    Smooth.Load(URL, false, $Link.hasClass("og-preventmodal"), $Link);
                }
            });

            $(document).on("keydown", "esc", function () {
                Smooth.RequestedURL = "";
                Navigation.Loading_Hide();
                Smooth.AbortAjax();
            });

            window.onpopstate = function (Event) {
                Smooth.StatesCount--;
                if (Event.state === null)
                    return;

                if (Event.state.Modal) {
                    if (Event.state.Modal_Type == "ShowHTMLGetDialog") {
                        if (Modals.GetModalByModalID(Event.state.ModalID) == null) {
                            Event.state.Modal_Data.PushState = false;
                            Event.state.Modal_Data.ModalID = Event.state.ModalID;
                            var Modal = OfficeGuy.Modals.ShowHTMLGetDialog(Event.state.Modal_Data);
                            Modal.data("PushState", true);
                        }
                        else
                            OfficeGuy.Modals.HideModalsAboveModal(Event.state.ModalID);
                    }
                    return;
                }
                if (Teva.SelectBox.VisibleMobileInstance != null) {
                    Teva.SelectBox.VisibleMobileInstance.HideResults(false, false);
                    Teva.SelectBox.VisibleMobileInstance = null;
                    return;
                }

                if (OfficeGuy.Modals.VisibleModals.length > 0) {
                    var VisibleModals = $(".modal").get().reverse();
                    for (var i = 0; i < VisibleModals.length; i++) {
                        OfficeGuy.Modals.Hide(VisibleModals[i], true);
                        if ($(VisibleModals[i]).data("modal-params").PushState)
                            return;
                    }
                }

                var URL = window.location.href;
                if (Smooth.CurrentHref !== URL && !Smooth.IsHash(Smooth.CurrentHref))
                    Smooth.Load(URL, true, false, null);
            };
        }
    }
}

$(function () {
    if (window.history && window.history.pushState) {
        $(document).ready(function () {
            if ($("#main-content").length > 0)
                OfficeGuy.Smooth.Init($("#main-content"));
        });
    }
});

(function ($) {
    // RegExp that matches opening and closing HTML, HEAD, BODY tags.
    // $1 = slash, $2 = tag name, $3 = attributes
    var rtag = /<(\/?)(html|head|body)(\s+[^>]*)?>/ig;

    // Unique id prefix for selecting placeholder elements.
    var prefix = 'hd' + +new Date();

    (<any>$).htmlDoc = function (str) {
        var // A collection of "intended" elements that can't be rendered
            // cross-browser with .innerHTML, for which placeholders must be
            // swapped.
            $Elements = $([]),

            // Input HTML string, parsed to include placeholder DIVs.
            Parsed,

            // A node under which a temporary DOM tree can be constructed.
            Root;

        // Replace HTML, HEAD, BODY tags with DIV placeholders.
        Parsed = str.replace(rtag, function (tag, slash, name, attrs) {

            var // Current intended / placeholder element index.
                Length = $Elements.length,

                // Temporary object in which to hold attributes.
                TempObject = {};

            // If this is an opening tag...
            if (!slash) {

                // Add an element of this name into the collection of elements. Note
                // that if a string of attributes is added at this point, it fails.
                $Elements = $Elements.add('<' + name + '/>');

                // If the original tag had attributes, create a temporary div with
                // those attributes. Then, copy each attribute from the temporary div
                // over to the temporary object.
                if (attrs) {
                    $.each($('<div' + attrs + '/>')[0].attributes, function (i, v) {
                        TempObject[v.name] = v.value;
                    });
                }

                // Set the attributes of the intended object based on the attributes
                // copied in the previous step.
                $Elements.eq(Length).attr(TempObject);
            }

            // A placeholder div with a unique id replaces the intended element's
            // tag in the parsed HTML string.
            return '<' + slash + 'div'
                + (slash ? '' : ' id="' + prefix + Length + '"') + '>';
        });

        // If placeholder elements were necessary...
        if ($Elements.length) {

            // Create the root node and append the parsed, place-held HTML.
            Root = $('<div/>').html(Parsed);

            // Replace each placeholder element with its intended element.
            $.each($Elements, function (i, v) {
                var $Element = Root.find('#' + prefix + i).before($Elements[i]);
                $Elements.eq(i).html($Element.contents());
                $Element.remove();
            });

            // Return the topmost intended element(s), sans text nodes.
            return Root.children();
        }

        // No placeholder elements were necessary, so just return a normal
        // jQuery-parsed HTML string.
        return $(str);
    };

})(jQuery);
